import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { removeAssetFromCollection } from '@/services/collection';

const useRemoveAssetFromCollection = () => {
  const [loading, setLoading] = useState(false);

  const handleRemoveAssetFromColleciton = async (
    collectionId: number,
    assetId: number,
    setIsRemove: Dispatch<SetStateAction<boolean>>,
  ) => {
    try {
      setLoading(true);
      await removeAssetFromCollection(collectionId, assetId);
      setLoading(false);
      toast.success('Remove artwork successfully!');
      setIsRemove(true);
    } catch (error: any) {
      setLoading(false);

      toast.error(error?.message);
    }
  };

  return { handleRemoveAssetFromColleciton, loading };
};

export default useRemoveAssetFromCollection;
